import React from 'react';
import styles from './BrowserFrameHeader.scss';
import { CircleSmallFilled } from '@wix/wix-ui-icons-common';
import { Text } from '@wix/design-system';
export const BrowserFrameHeader = _ref => {
  let {
    url
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.browserFrameHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.browserFrameHeaderKnobs
  }, /*#__PURE__*/React.createElement(CircleSmallFilled, null), /*#__PURE__*/React.createElement(CircleSmallFilled, null), /*#__PURE__*/React.createElement(CircleSmallFilled, null)), url && /*#__PURE__*/React.createElement("div", {
    className: styles.browserFrameHeaderUrl
  }, /*#__PURE__*/React.createElement(Text, {
    secondary: true,
    size: "tiny"
  }, url)), /*#__PURE__*/React.createElement("div", null));
};
//# sourceMappingURL=BrowserFrameHeader.js.map